import axios from 'axios';
import qs from 'qs';
import { BASE_URL } from '../util/constants';

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
});

export const generateUrl = (endpoint, params) => {
  const queryString = api.defaults.paramsSerializer(params);
  return `${api.defaults.baseURL}${endpoint}?${queryString}`;
};

const apiClient = {
  get: async (url, params = {}) => {
    try {
      const response = await api
        .get(url, { params });
      return response.data;
    } catch (error) {
      console.error("GET Error:", error);
      throw error.response ? error.response.data : error;
    }
  },
}


export default apiClient;